import { useEffect, useContext, useState } from "react";

import UserContext from "../contexts/UserContext";
import Utils from "../Utils";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import AccessibleHotelsSection from "../components/hotelRepresentative/AccessibleHotelsSection";
import ManagePhotoshootsSection from "../components/common/ManagePhotoshootsSection";
import PhotoshootRequestSection from "../components/hotelRepresentative/PhotoshootRequestSection";
import PhotographerManagePhotoshootsSection from "../components/photographer/ManagePhotoshootsSection";

const Dashboard = (props) => {
  const { userData, isCertified, isCertificationRequired, siteStatuses } =
    useContext(UserContext);

  const [certsucc, setCertsucc] = useState(userData?.certsucc || false);
  const [hotelId, setHotelId] = useState(Utils.getSelectedHotelId() || 0);

  useEffect(() => {
    if (Utils.isLoggedIn() === false) {
      window.location.href = "/";
      return;
    } else {
      Utils.removeFromUserData("certsucc");
    }
  }, []);

  const { certificate } = userData;

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  /* Classes for specific status */
  const statusClasses = {
    "In-Process": "status-pill inline-block bg-yellow-100 text-yellow-800",
    Pending: "status-pill inline-block bg-pink-50 text-pink-700",
    Completed: "status-pill inline-block bg-gray-200 text-gray-700",
  };
  /* Labels for status */
  const getStatusLabel = (status) => {
    const code = Number(status);

    if (code === 0 || code === 1) return "Pending";
    if (code >= 2 && code <= 6) return "In-Process";
    if (code === 7 || code === 8) return "Completed";

    return "Unknown";
  };

  const renderBell = (st) => {
    const redStatus = [1, 2, 3, 5];
    return (
      <div>
        <i
          className={`fas fa-bell text-${redStatus.includes(Number(st)) ? "red" : "green"}-500`}
        ></i>{" "}
        {siteStatuses.statusToBe[st + 1]}
      </div>
    );
  };

  const hotelDetailsFromAttrs = (attrs) => {
    return attrs.split("#");
  };

  const [brandDetails, setBrandDetails] = useState([]);
  /* Getting Hotel Details only for HR */
  useEffect(() => {
    if (Utils.isHR()) {
      axios
        .get(Utils.apiUrl(`hr/brandDetail`), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            setBrandDetails(res.data.brand);
          }
        })
        .catch((err) => {
          //callback(false, err.message);
        });
    } else if (Utils.isAMT() || Utils.isHotelOwner()) {
      setBrandDetails({ hotel: Utils.getUserData().hotel_name });
    }
  }, []);

  const [activePhotoshoot, setActivePhotoshoot] = useState([]);
  /*useEffect(() => {
    if (isCertified()) {
      axios
        .get(Utils.apiUrl(`photoshoot/activePhotoshoots`), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            setActivePhotoshoot(res.data.data);
          }
        })
        .catch((err) => {
          //callback(false, err.message);
        });
    }
  }, []);*/

  const nextAction = (status) => {
    const code = parseInt(status);
    if (code >= 1 && code <= 2) return "Shot-list";
    if (code >= 3 && code <= 4) return "Styling deck";
    if (code >= 5 && code <= 4) return "Recce deck";
    else return "View Details";
  };

  const showCertSuccBox = () => {
    return (
      <>
        {
          <div className="rounded p-4 text-xl bg-green-50 my-4">
            Once{" "}
            <a
              href={Utils.apiUrl(
                `admin/resources/download?url=${encodeURIComponent("https://auraphotosblob.blob.core.windows.net/aura-photos/Resources/photographer/Shot List Template.xlsx")}&name=${encodeURIComponent("Shot List Template.xlsx")}`,
              )}
              className="text-blue-600"
              title="Download Shot List template"
              download
            >
              Shot List
            </a>{" "}
            is prepared, please reach out to the{" "}
            <a
              href={Utils.apiUrl(
                `admin/resources/download?url=${encodeURIComponent("https://auraphotosblob.blob.core.windows.net/aura-photos/Resources/hotel/APEC Certified Photographer List.pdf")}&name=${encodeURIComponent("APEC Certified Photographer List.pdf")}`,
              )}
              className="text-blue-600"
              title="Download certified photographers list"
              download
            >
              Certified Photographers
            </a>{" "}
            for a quote. Once Photographer is confirmed and shoot dates
            finalized, please login to AURA to start your photography Process.
            <div className="mt-3">
              Please refer to the following resources:
              <ul className="list-disc list-inside text-lg mt-2 ml-5 line-height-1.5">
                <li>
                  <a
                    href={Utils.apiUrl(
                      `admin/resources/download?url=${encodeURIComponent("https://auraphotosblob.blob.core.windows.net/aura-photos/Resources/photographer/Shot List Template.xlsx")}&name=${encodeURIComponent("Shot List Template.xlsx")}`,
                    )}
                    className="text-blue-600"
                    title="Download Shot List template"
                    download
                  >
                    Shot List
                    <i className="fas fa-download"></i>
                  </a>
                </li>
                <li>
                  <a
                    href={Utils.apiUrl(
                      `admin/resources/download?url=${encodeURIComponent("https://auraphotosblob.blob.core.windows.net/aura-photos/Resources/hotel/APEC Certified Photographer List.pdf")}&name=${encodeURIComponent("APEC Certified Photographer List.pdf")}`,
                    )}
                    className="text-blue-600"
                    title="Download APEC Certified Photographers List"
                    download
                  >
                    APEC Certified Photographers List
                    <i className="fas fa-download"></i>
                  </a>
                </li>
                <li>
                  <a
                    href={Utils.apiUrl(
                      `admin/resources/download?url=${encodeURIComponent("https://auraphotosblob.blob.core.windows.net/aura-photos/Resources/hotel/APEC Photography Governance.pdf")}&name=${encodeURIComponent("APEC Photography Governance.pdf")}`,
                    )}
                    className="text-blue-600"
                    title="Download APEC Photography Governance"
                    download
                  >
                    APEC Photography Governance
                    <i className="fas fa-download"></i>
                  </a>
                </li>
                <li>
                  <a
                    href={Utils.apiUrl(
                      `admin/resources/download?url=${encodeURIComponent("https://auraphotosblob.blob.core.windows.net/aura-photos/Resources/hotel/APEC Photoshoot Action Plan.pdf")}&name=${encodeURIComponent("APEC Photoshoot Action Plan.pdf")}`,
                    )}
                    className="text-blue-600"
                    title="Download APEC Photoshoot Action Plan"
                    download
                  >
                    APEC Photoshoot Action Plan
                    <i className="fas fa-download"></i>
                  </a>
                </li>
              </ul>
              <div className="mt-3">
                Click the below Hotel card to start your Photoshoot Project.
                <br />
                If you do not see your hotel, you can request access by clicking
                on "Request Access to Additional Hotel" card
              </div>
            </div>
          </div>
        }
      </>
    );
  };

  return (
    <>
      <div className="container mx-auto px-8 py-8">
        <div className="h1-wrapper">
          <h1 className="text-3xl font-bold text-gray-800">
            {Utils.panelTitle()}
          </h1>
          {isCertified() && (
            <>
              <div
                className="certification-icon-header valid"
                title="Certification Status"
              >
                <i className="fas fa-certificate"></i>
              </div>
              {isCertificationRequired() &&
                !_.isEmpty(certificate.expires_by) && (
                  <div className="ml-2 text-sm text-gray-600">
                    <p className="text-md font-bold">
                      Photography Course Certification Complete
                    </p>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-green-500">Valid till:</span>
                      <span className="badge flex items-center gap-2">
                        <i
                          className="fas fa-calendar-alt"
                          style={{ color: "#FF9362" }}
                        ></i>
                        {moment(certificate.expires_by).format("DD-MMM-YYYY")}
                      </span>
                    </div>
                  </div>
                )}
              {!isCertificationRequired() && (
                <div className="ml-2 text-gray-600">
                  <p className="text-md font-bold">Certification not needed</p>
                </div>
              )}
            </>
          )}
          {!isCertified() && (
            <>
              <div
                className="certification-icon-header invalid"
                title="Certification Status"
              >
                <i className="fas fa-exclamation-triangle"></i>
              </div>
              {_.get(certificate, "attempted", false) && (
                <div>
                  <strong>Expired on:</strong>{" "}
                  {moment(certificate.expires_by).format("DD-MMM-YYYY")}
                </div>
              )}
              {!_.get(certificate, "attempted", false) && (
                <>APEC Photography Process Course not completed</>
              )}
            </>
          )}
        </div>

        {/* <!-- Notifications Section --> */}
        {/* <!-- Certification Status --> */}
        {/*<HrCertification />*/}

        {isCertified() && !Utils.isPhotographer() && (
          <>
            {showCertSuccBox()}
            <AccessibleHotelsSection
              userData={userData}
              brandDetails={brandDetails}
              onHotelSelect={(hotelId) => setHotelId(hotelId)}
            />
          </>
        )}

        {!isCertified() && (
          <div className="flex items-start gap-3 rounded-lg border border-yellow-300 bg-yellow-50 p-4 text-yellow-800">
            <svg
              className="h-8 w-8 flex-shrink-0 text-yellow-500"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v4m0 4h.01M5.07 19h13.86c1.54 0 2.5-1.67 1.73-3L13.73 4c-.77-1.33-2.69-1.33-3.46 0L3.34 16c-.77 1.33.19 3 1.73 3z"
              />
            </svg>

            <div>
              <h3 className="font-semibold text-xl">Certification Required</h3>
              <p className="mt-1 text-xl">
                You must complete your certification before proceeding. Please
                click on get certified.
              </p>

              <a
                href="/get-certified"
                className="mt-3 inline-block rounded-md bg-yellow-600 px-5 py-5 text-xl font-medium text-white hover:bg-yellow-700"
              >
                Get Certified
              </a>
            </div>
          </div>
        )}

        {isCertified() && !Utils.isPhotographer() && (
          <ManagePhotoshootsSection selectedHotelId={hotelId} />
        )}

        {isCertified() && Utils.isPhotographer() && (
          <PhotographerManagePhotoshootsSection />
        )}

        {/* <!-- Photoshoot Request Section --> }
        {isCertified() &&
          !Utils.isPhotographer() &&
          activePhotoshoot.length > 0 && (
            <PhotoshootRequestSection
              brandDetails={brandDetails}
              activePhotoshoot={activePhotoshoot}
              siteStatuses={siteStatuses}
              formatDate={formatDate}
              nextAction={nextAction}
              renderBell={renderBell}
            />
          )*/}
      </div>
    </>
  );
};

export default Dashboard;
